
<ion-grid *ngIf="userData$ | async; let userData">
  <ion-row class="ion-align-items-center">
    <ion-col size="auto">
      <div class="user-avatar">
        <app-user-avatar
          [personalData]="userData?.personalData"
          [isAdmin]="isAdmin$ | async"
          [isDoctor]="isDoctor$ | async"
        >
        </app-user-avatar>
      </div>
    </ion-col>

    <ion-col>
      <ion-text>
        <span *ngIf="userData?.personalData?.surname">
          {{ userData?.personalData?.surname }} {{ userData?.personalData?.name }}
        </span>
        <span *ngIf="!userData?.personalData?.surname">
          <span>{{
            userData?.userMe?.associationId?.pass_auth || userData?.personalData?.fiscalCode
          }}</span>
        </span>
      </ion-text>
    </ion-col>
  </ion-row>
</ion-grid>

<ion-list>
  
  <ion-item lines="none" button routerLink="/account">
    <ion-icon slot="start" [src]="'account' | getIcon"></ion-icon>
    <ion-label>Account</ion-label>
  </ion-item>

  
  <ion-item lines="none" button *ngIf="isAdmin$ | async" (click)="onAdminPanel()">
    <ion-icon slot="start" [src]="'cog-outline' | getIcon"></ion-icon>
    <ion-label>Pannello amministrazione</ion-label>
  </ion-item>

  
  <ion-item lines="none" button *c3ShowTrecEnv="'development'" (click)="onLeaveFeedback()">
    <ion-icon slot="start" [src]="'message-alert-outline' | getIcon"></ion-icon>
    <ion-label>Lascia un feedback</ion-label>
  </ion-item>

  <ion-item lines="none" button *ngIf="configSupporto" (click)="goToSupport()">
    <ion-icon slot="start" [src]="'help-circle-outline' | getIcon"></ion-icon>
    <ion-label>Supporto</ion-label>
  </ion-item>


  
  

  
  <ion-item lines="none">
    
    <ion-label>Cambia tema</ion-label>

    <ion-buttons slot="end">
      <ion-button
        size="small"
        class="app-theme-switch-btn"
        (click)="onSetThemeColor('default')"
        c3Tooltip="Default"
      >
        <ion-icon slot="icon-only" size="small" [src]="'reload' | getIcon"></ion-icon>
      </ion-button>

      <ion-button
        size="small"
        class="app-theme-switch-btn"
        (click)="onSetThemeColor('light')"
        c3Tooltip="Chiaro"
        [color]="(isDarkMode$ | async) ? undefined : 'secondary'"
      >
        <ion-icon slot="icon-only" size="small" [src]="'weather-sunny' | getIcon"></ion-icon>
      </ion-button>

      <ion-button
        size="small"
        class="app-theme-switch-btn"
        (click)="onSetThemeColor('dark')"
        c3Tooltip="Scuro"
        [color]="(isDarkMode$ | async) ? 'secondary' : undefined"
      >
        <ion-icon slot="icon-only" size="small" [src]="'moon-waning-crescent' | getIcon"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-item>

  
  <ion-item lines="none" button (click)="onLogout()">
    <ion-icon slot="start" [src]="'exit-to-app' | getIcon"></ion-icon>
    <ion-label>Logout</ion-label>
  </ion-item>
</ion-list>
